import { createJourneyRouter, JourneyGlobalLayout, JourneyLayoutMaxWidth } from '@cash-web/shared-journey-feature-main'

import { activityJourneyRoutes } from './lib/activity/routes'
import { bitcoinJourneyRoutes } from './lib/bitcoin/routes'
import { cashJourneyRoutes } from './lib/cash/routes'
import { devicesJourneyRoutes } from './lib/devices/routes'
import { JourneyDefaultError } from './lib/error/components/JourneyDefaultError'
import { errorJourneyRoutes } from './lib/error/routes'
import { flowJourneyRoutes } from './lib/flow/routes'
import { investingJourneyRoutes } from './lib/investing/routes'
import { paychecksJourneyRoutes } from './lib/paychecks/routes'
import { poolsJourneyRoutes } from './lib/pools/routes'
import { savingsJourneyRoutes } from './lib/savings/routes'
import { settingsJourneyRoutes } from './lib/settings/routes'
import { stocksJourneyRoutes } from './lib/stocks/routes'

export const journeyRoutes = [
  {
    path: '/*',
    element: <JourneyGlobalLayout fallbackComponent={JourneyDefaultError} />,
    errorElement: <JourneyDefaultError />,
    children: [
      ...flowJourneyRoutes,
      {
        path: 'dl/view/*',
        element: <JourneyLayoutMaxWidth />,
        children: [
          ...errorJourneyRoutes,
          ...activityJourneyRoutes,
          ...bitcoinJourneyRoutes,
          ...cashJourneyRoutes,
          ...devicesJourneyRoutes,
          ...savingsJourneyRoutes,
          ...investingJourneyRoutes,
          ...settingsJourneyRoutes,
          ...paychecksJourneyRoutes,
          ...poolsJourneyRoutes,
          ...stocksJourneyRoutes,
        ],
      },
    ],
  },
]

export const journeyRouter = createJourneyRouter(journeyRoutes)
